export default {
  ru: {
    categoryTitle: 'Выберите категорию тренировки',
    trainingTitle: 'Выберите, какое занятие<br> вы хотите посетить',
    scheduleTitle: 'По вашему запросу подходят<br> следующие тренировки',
    formTitle: 'Записаться на тренировку <mark>{training}</mark>',
    next: 'Далее',
    badConnection: 'Ошибка соединения',
    notPossible: 'Не удалось подключиться к сервису, пожалуйста, попробуйте повторить попытку позднее или обратитесь к администратору',
    goHome: 'На главную',
    pending: 'Загрузка данных.<br>Пожалуйста, подождите ...',
    notFound: 'Ничего не найдено',
    empty: 'Не удалось найти подходящих тренировок, попробуйте выбрать что-то другое',
    pickAnother: 'Выбрать другое занятие',
    clearFilters: 'Сбросить фильтр',
    count: 'Осталось мест: {count}',
    duration: '0 минут | {n} минута | {n} минуты | {n} минут',
    today: 'сегодня',
    canceled: 'Занятие отменено',
    surnameLabel: 'Фамилия',
    surnamePlaceholder: 'Введите вашу фамилию',
    surnameError: 'Фамилия введена неверно',
    nameLabel: 'Имя',
    namePlaceholder: 'Введите ваше имя',
    nameError: 'Имя введено неверно',
    patronymicLabel: 'Отчество',
    patronymicPlaceholder: 'Введите ваше отчество',
    patronymicError: 'Отчество введено неверно',
    submit: 'Записаться',
    completeTitle: 'Поздравляем, вы успешно записались на тренировку!',
    completeInfo: 'Ваша тренировка из категории <mark>{name}</mark> состоится <mark>{date}</mark>.<br> До скорых встреч!',
    trainingPlaceholder: 'Занятие',
    trainingSearchPlaceholder: 'Поиск по названию',
    trainingNotfound: 'Такого занятия нет',
    trainerPlaceholder: 'Тренер',
    trainerSearchPlaceholder: 'Поиск по имени и фамилии',
    trainerNotfound: 'Такого тренера нет',
    startAt: 'с {time}',
    startAtPlaceholder: 'С ...',
    endAt: 'до {time}',
    endAtPlaceholder: 'До ...',
  },
  en: {
    // en
  },
};
